/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IChartDataResponse {
  /** Даты для оси X **/
  datesLabels: string[] | null;
  /** Значения для прогноза цены **/
  secondLineValues: (number | null)[] | null;
  /** Наибольшее значение для оси Y **/
  maxChartValue: number | null;
  /** Наименьшее значение для оси Y **/
  minChartValue: number | null;
  /** Упорядоченный список значений для сплошной синей линии/количества проданных квартир **/
  firstLineValues: (number | null)[] | null;
  /** Шаг для оси Y **/
  labelStep: number;
  /** Массив распроданных квартир **/
  labels?: ILabels[];
}

export interface ILabels {
  roomStats: string[];
}

export enum EChartType {
  Price,
  Sales,
}
